import type { ValueOf } from 'type-fest';
import type { DynamicImage } from '../dynamic-image/dynamic-image.types';

export const headingSizes = {
  large: 'large',
  medium: 'medium',
} as const;

export const headingThemes = {
  emphasis: 'emphasis',
};

export const themes = {
  narrowImage: 'narrow-image',
} as const;

export type ImageLinkCard = {
  headingSize?: ValueOf<typeof headingSizes>;
  headingTheme?: ValueOf<typeof headingThemes>;
  href: string;
  image?: DynamicImage;
  shouldOpenInNewTab?: boolean;
  tag?: string;
  text?: string;
  theme?: ValueOf<typeof themes>;
  title: string;
};
